import React from "react";
// nodejs library to set properties for components

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Grid, { GridProps } from "@material-ui/core/Grid";

const styles = {
  grid: {
    margin: "0 -15px !important",
    width: "unset"
  }
};
export interface GridContainerProps extends GridProps {

}
const useStyles = makeStyles(styles);

export default function GridContainer(props: GridProps) {
  const classes = useStyles();

  return (
    <Grid container {...props} className={classes.grid}>

    </Grid>
  );
}

